<template>
  <div class="page-outbox">
  	<form name="loginForm" class="login-form" action=javascript:void(0);>
  		<img class="user-avatar" src="../../assets/logo-icon.png" />
  		<input class="form-input username" v-model="username" type="text" placeholder="请输入登录邮箱" />
  		<input class="form-input password" v-model="password" type="password" placeholder="请输入密码" />
  		<button class="form-btn" @click="loginSub" v-html="login_text">{{login_text}}</button>
  		<p class="form-link">
  			<a href="javascript:void(0)" @click="forgetPW">忘记密码</a>
  			<a href="javascript:void(0)" @click="toRegister">立即注册</a>
  		</p>
  	</form>
  </div>
</template>

<script>
	export default {
    name: '',
    data () {
      return {
		login_text: '',
      	username: '',
      	password: ''
      }
	},
	mounted(){
		if(this.ifWeChat()){
			this.login_text = '立即绑定';
		}else{
			this.login_text = '登&nbsp;&nbsp;陆';
		}
	},
    methods:{
    	loginSub(){
    		if(!this.username){
    			this.$toast('请输入登录邮箱');
    			return;
    		}
    		if(!this.password){
    			this.$toast('请输入密码');
    			return;
    		}
    		if(!/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(this.username)){
    			this.$toast('请输入正确格式的邮箱');
    			return;
    		}
			//测试账号 aloneshen2003@163.com/123456
			console.log(this.$store.state.wxOpenId);
    		this.$cHttp.post('customers/login',{
				partner:this.$systemConfig.partner,
				apikey:this.$systemConfig.apikey,
				cus_email:this.username,
				cus_password:this.password,
				cus_wxopenid:this.$store.state.wxOpenId
	      	}).then((res)=>{
				if(res.status&&res.status==1){
					//存储用户信息并跳转页面
					this.$store.commit('setUserInfo',res.data);
					this.$store.commit('setWxOpenId',res.data.cus_wxopenid);
					if(res.data.cus_wxopenid != ''){
						this.$store.commit('setWxState','1');  
					}
					//查询购物车信息
					this.$cHttp.post('shopcart/index',{
						partner:this.$systemConfig.partner,
						apikey:this.$systemConfig.apikey,
						user_id:this.$store.state.userInfo.user_id
					}).then((res)=>{
						if(res.status&&res.status==1){
							//修改购物车数量
							this.$store.commit('setShopCount',res.data.total_num);
						}else{
							this.$toast(res.error_msg)
						}
					}).catch((msg)=>{
					this.$toast(msg);
					})
					if(this.$route.query.backRoute){
						this.$router.replace({path:this.$route.query.backRoute});
					}else{
						this.$router.replace({path:'/goodsList'});
					}
				}else{
					this.$toast(res.error_msg)
				}
	      	}).catch((msg)=>{
	      		this.$toast(msg)
	      	})
    		console.log('login');
    	},
    	forgetPW(){
    		console.log('忘记密码');
    	},
    	toRegister(){
    		this.$router.push({path:'/Register'})
    	},
		ifWeChat() {
			let ua = window.navigator.userAgent.toLowerCase();
			return ua.match(/MicroMessenger/i) == 'micromessenger';
		}
    },
    components:{

    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" type="text/scss" rel="stylesheet/scss" scoped>
.page-outbox{
	display: flex;
	align-items: center;
	bottom:0;
	z-index: 1000;
	background:url(../../assets/login-bg.jpg) no-repeat center;
	background-size:cover;
	background-color: #e16c6d;
}
.login-form{
	width: 2.6rem;
	margin: 0 auto;
	color:#fff;
	.user-avatar{
		position: relative;
		top: -.3rem;
		display: block;
		margin: 0 auto;
		width: .8rem;
		height:.8rem;
		border:.04rem solid #fff;
		border-radius: .8rem;
		background-color:#fff;
	}
	.form-input{
		margin-bottom: .1rem;
		width: 100%;
		line-height: .3rem;
		font-size: .16rem;
		color: #fff;
		text-indent: .4rem;
		border:none;
		border-bottom: 1px solid rgba(255,255,255,.4);
		background-color: transparent;
		/*background-color: rgba(255,255,255,.1);*/
		background-repeat:no-repeat;
		background-size: .2rem .2rem;
		background-position: .08rem center;
		&.username{
			background-image:url(../../assets/user-icon.png);
		}
		&.password{
			background-image:url(../../assets/password-02.png);
		}
	}
	.form-btn{
		margin-top: .1rem;
		width: 100%;
		line-height: .3rem;
		font-size: .16rem;
		color: $mainColor;
		border:none;
		background-color: #fff;
		&:active{
			opacity: .7;
		}
	}
	.form-link{
		margin-top: .1rem;
		display: flex;
		justify-content: space-between;
		a{
			font-size: .12rem;
			color: #fff;
		}
	}
}

::-webkit-input-placeholder{
	color:rgba(255,255,255,.7);
}
:-moz-input-placeholder{
	color:rgba(255,255,255,.7);
}
::-moz-input-placeholder{
	color:rgba(255,255,255,.7);
}
:-ms-input-placeholder{
	color:rgba(255,255,255,.7);
}
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue